module.exports = __webpack_public_path__ + "prod-assets/r29bug-c10af6.obj";


//////////////////
// WEBPACK FOOTER
// ./assets/r29bug.obj
// module id = 22
// module chunks = 0